import { idlFactory as airdropIdlFactory } from '../declarations/airdrop';
import { Actor, HttpAgent } from '@dfinity/agent';

// Get the host URL based on the network
const host = process.env.DFX_NETWORK === 'ic' 
  ? 'https://ic0.app' 
  : 'http://127.0.0.1:4943';

// Create a function to get or create an actor
const getActor = async (requireAuth = false) => {
  // If authentication is required, check for authenticated agent
  if (requireAuth && !window.ic?.agent) {
    throw new Error("Please connect with Internet Identity first");
  }

  // Create the actor with appropriate agent
  return Actor.createActor(airdropIdlFactory, {
    agent: window.ic?.agent || new HttpAgent({ host }),
    canisterId: process.env.DFX_NETWORK === 'ic'
      ? 'a4gq6-oaaaa-aaaab-qaa4q-cai'
      : 'be2us-64aaa-aaaaa-qaabq-cai'
  });
};

export const airdropService = {
  // Get all wallets
  async getWallets() {
    try {
      const actor = await getActor(true); // Requires auth
      const wallets = await actor.getWallets();
      return wallets.map(wallet => ({
        ...wallet,
        lastReward: wallet.lastReward ? new Date(Number(wallet.lastReward) / 1000000).toISOString() : null
      }));
    } catch (error) {
      console.error('Error fetching wallets:', error);
      throw error;
    }
  },

  // Get airdrop configuration
  async getConfig() {
    try {
      const actor = await getActor(false); // Public access
      return await actor.getConfig();
    } catch (error) {
      console.error('Error fetching config:', error);
      throw error;
    }
  },

  // Fetch token holders from Solana
  async fetchTokenHolders() {
    try {
      const actor = await getActor(true); // Requires auth
      const wallets = await actor.fetchTokenHolders();
      return wallets.map(wallet => ({
        ...wallet,
        lastReward: wallet.lastReward ? new Date(Number(wallet.lastReward) / 1000000).toISOString() : null
      }));
    } catch (error) {
      console.error('Error fetching token holders:', error);
      throw error;
    }
  },

  // Get selected wallets for airdrop
  async selectRandomWallets() {
    try {
      const actor = await getActor(true); // Requires auth
      const wallets = await actor.selectRandomWallets();
      return wallets.map(wallet => ({
        ...wallet,
        lastReward: wallet.lastReward ? new Date(Number(wallet.lastReward) / 1000000).toISOString() : null
      }));
    } catch (error) {
      console.error('Error selecting random wallets:', error);
      throw error;
    }
  },

  // Get event log
  async getEventLog() {
    try {
      const actor = await getActor(false); // Public access
      const events = await actor.getEventLog();
      return events.map(event => ({
        ...event,
        timestamp: Number(event.timestamp)
      }));
    } catch (error) {
      console.error('Error fetching event log:', error);
      throw error;
    }
  },

  // Get transaction log
  async getTransactionLog() {
    try {
      const actor = await getActor(false); // Public access
      const transactions = await actor.getTransactionLog();
      return transactions.map(tx => ({
        ...tx,
        timestamp: Number(tx.timestamp)
      }));
    } catch (error) {
      console.error('Error fetching transaction log:', error);
      throw error;
    }
  },

  // Get system status
  async getSystemStatus() {
    try {
      const actor = await getActor(false); // Public access
      return await actor.getSystemStatus();
    } catch (error) {
      console.error('Error fetching system status:', error);
      throw error;
    }
  }
}; 